import Button from 'antd/lib/button';
import { BaseButtonProps } from 'antd/lib/button/button';
import Tooltip from 'antd/lib/tooltip';
import saveAs from 'file-saver';
import Papa from 'papaparse';
import { useImportContext } from 'src/components/import';
import { PjmLoadReductionType } from 'src/domain/pjm/dto/enums';
import { PjmLocationDto } from 'src/domain/pjm/dto/PjmLocationDto';

type PjmLocationsDownloadTemplateSelectedItemsButtonProps = BaseButtonProps & {
    locations: PjmLocationDto[];
};

export const PjmLocationsDownloadTemplateSelectedItemsButton = ({
    locations,
    ...buttonProps
}: PjmLocationsDownloadTemplateSelectedItemsButtonProps) => {
    const { csvConfig } = useImportContext();
    const columns = csvConfig.map(it => it.column);

    const title = locations.length === 1 ? `Download Template with 1 location` : `Download Template with ${locations.length} locations`;

    const handleClick = () => {
        const rows = locations.map(location => {
            const redactionInfoMap = new Map<PjmLoadReductionType, number | undefined>();
            location.reductionInfo?.forEach(it => {
                redactionInfoMap.set(it.reductionType!, it.reductionValue);
            });

            return [
                /** Location ID* */ location.id,
                /** Peak Load Contribution (kW) */ location.profileInfo?.peakLoadContribution || '',
                /** Winter Peak Load (kW) */ location.profileInfo?.winterPeakLoad || '',
                /** Capacity Loss Factor */ location.profileInfo?.capacityLossFactor || '',
                /** Energy Loss Factor */ location.profileInfo?.energyLossFactor || '',
                /** Max Load (kW) */ location.profileInfo?.maxLoad || '',
                /** Manufacturing (kW) */ redactionInfoMap.get(PjmLoadReductionType.MANUFACTURING),
                /** HVAC (kW) */ redactionInfoMap.get(PjmLoadReductionType.HVAC),
                /** Generator (kW) */ redactionInfoMap.get(PjmLoadReductionType.GENERATOR),
                /** Number of Generators */ location.generatorCount,
                /** Batteries (kW) */ redactionInfoMap.get(PjmLoadReductionType.BATTERIES),
                /** Lighting (kW) */ redactionInfoMap.get(PjmLoadReductionType.LIGHTING),
                /** Water Heaters (kW) */ redactionInfoMap.get(PjmLoadReductionType.WATER_HEATERS),
                /** Refrigeration (kW) */ redactionInfoMap.get(PjmLoadReductionType.REFRIGERATION),
                /** Plug Load (kW) */ redactionInfoMap.get(PjmLoadReductionType.PLUG_LOAD),
                /** Computing (kW) */ redactionInfoMap.get(PjmLoadReductionType.COMPUTING),
            ];
        });
        downloadTemplate(columns, rows, 'bulk-update-location-template-example');
    };

    return (
        <Tooltip title="Download the CSV template and update it with your data to bulk update.">
            <Button onClick={handleClick} {...buttonProps}>
                {title}
            </Button>
        </Tooltip>
    );
};

function downloadTemplate(csvColumns: string[], rows: any[][], templateName: string = 'bulk-update-template') {
    const csvData = Papa.unparse([csvColumns, ...rows], {
        quotes: false,
        quoteChar: '"',
        escapeChar: '"',
        delimiter: ',',
        header: true,
        escapeFormulae: true,
    });
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8' });
    saveAs(blob, `${templateName}.csv`);
}
